document.addEventListener('DOMContentLoaded', () => {
  init();
});
 
function init() {
  initSizeGuide();
  initRecommendedProducts();
}

// Init Size Guide
function initSizeGuide() {
  const sizeGuideButton = document.querySelector('[js-product="sizeGuideButton"]');
  const sizeGuideCloseButton = document.querySelector('[js-product="sizeGuideCloseButton"]');
  const sizeGuideBackgroundOverlay = document.querySelector('[js-product="sizeGuideBackgroundOverlay"]'); 

  if (!sizeGuideButton || !sizeGuideCloseButton) {
    return;
  }

  sizeGuideButton.addEventListener('click', () => {
    handleSizeGuideClick();
  });

  sizeGuideCloseButton.addEventListener('click', () => {
    handleSizeGuideCloseClick();
  });

  if (!sizeGuideBackgroundOverlay) {
    return;
  }

  sizeGuideBackgroundOverlay.addEventListener('click', () => {
    handleSizeGuideCloseClick();
  });
}

// Handle the size guide button click
function handleSizeGuideClick() {
  const sizeGuideModal = document.querySelector('[js-product="sizeGuideModal"]'); 
  const sizeGuideBackgroundOverlay = document.querySelector('[js-product="sizeGuideBackgroundOverlay"]'); 

  if (!sizeGuideModal || !sizeGuideBackgroundOverlay) {
    return;
  }

  sizeGuideModal.classList.remove('is-hidden');
  sizeGuideBackgroundOverlay.classList.remove('is-hidden');

  document.body.style.height = '100vh';
  document.body.style.overflowY = 'hidden';
}

function handleSizeGuideCloseClick() {
  const sizeGuideModal = document.querySelector('[js-product="sizeGuideModal"]'); 
  const sizeGuideBackgroundOverlay = document.querySelector('[js-product="sizeGuideBackgroundOverlay"]'); 

  if (!sizeGuideModal || !sizeGuideBackgroundOverlay) {
    return;
  }

  sizeGuideModal.classList.add('is-hidden');
  sizeGuideBackgroundOverlay.classList.add('is-hidden');

  document.body.style.height = 'initial';
  document.body.style.overflowY = 'initial';
}

// Init Recommended Products
function initRecommendedProducts() {
  const recommendedProductAddToCart = [...document.querySelectorAll('[js-recommended-product="addToCart"]')];

  recommendedProductAddToCart.forEach((addToCart) => {
    addToCart.addEventListener('click', () => {
      const variantId = addToCart.dataset.variantId;
      console.log(variantId);
      let quantity_bubble = document.querySelector(".cart-count-bubble");
      if(quantity_bubble) {
        if(quantity_bubble.classList.contains('cs__cart-count-bubble-hide')) {
          setTimeout(function(){
            quantity_bubble.classList.remove('cs__cart-count-bubble-hide');
          }, 1000);
        }
      }
      if (variantId) {
        addVariantToCart(variantId, 1);
      }
    });
  });
}

// Add ID and Quantity to cart
function addVariantToCart(id, quantity) {
  const formData = {
    'items': [{
    'id': id,
    'quantity': quantity
    }]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then((response) => response.json())
  .then((data) => {
    if (data.items) {
      console.log("product added..");
      const cartCount = [...document.querySelectorAll('.cart-count-bubble')];
      
      cartCount.forEach((count) => {
        count.firstChild.innerText = `${Number(count.firstChild.innerText) + 1}`
      });
      
      return;
    }
    
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}



// accordion section js
$('.net-cvr').next('div').show();
$('.net-cvr').addClass('active');
$('.net-cvr').click(function () {
    $(this).next('div').toggle('fast');
    $(this).toggleClass('active');
    $('.net-cvr').not(this).removeClass('active').next('div').hide('fast');
});


